export const isValidUrl = (url: any): boolean => {
  // Return false if url is not a string
  if (typeof url !== 'string') {
    return false;
  }

  // If URL doesn't have protocol, add https:// prefix
  const urlWithProtocol = url.match(/^(https?|ftp):\/\//)
    ? url
    : `https://${url}`;
  return /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(urlWithProtocol);
};
